define(["utils/findElements"],
	function(findElements) { 
        
        function findNum(source, parse){
            //Not very efficient search, replace with RegExp
            source = source.replace(/\s+/g, "");
            source = source.replace(/,/g, "");
            var num = NaN;
            for(var i = 0; isNaN(num) && i < source.length ;i++){
                num = parse(source.substr(i));
            }    
            return isNaN(num)?null:num;
        }
        
        function getContent(element, valueFormat){
            var content = element.value || element.innerText || element.textContent;
            if(content){
                if(valueFormat == "number"){
                    content = findNum(content, parseFloat);
                }
                if(valueFormat == "int"){
                    content = findNum(content, parseInt);
                }
            }
            return content;             
        }
        
        var saveContent = function(options, callback){
            var selectors = options.selectors,
                datapoint = options.datapoint,
                key = options.key,
                valueFormat = options.valueFormat || "string",
                saveFunc = (datapoint == "a")?uDash.saveAttribute:uDash.saveMeta,
                result = false;
            for(var i = 0;i < selectors.length;i++){
                var selector = selectors[i];
                var elements = findElements(selector);  
                if(elements && elements.length){
                    for(var j = 0; j < elements.length;j++){
                        var element = elements[j];
                        var content = getContent(element, valueFormat);
                        if(content){
                            saveFunc(key, content);   
                            result = true;                                                               
                        };
                    }
                }                  
            };
            callback(result || !options.reportErrors ? null:new Error("No content found"));
        };
		return saveContent;
	}
);



//////////////////
// WEBPACK FOOTER
// ./responses/data-collection/saveContent/saveContent.js
// module id = 12
// module chunks = 2